<template>
  <div class="wrapper">
    <div class="center-item">
      <div class="center-title">
        澳大利亚  布里斯班处理中心
        <div class="line"></div>
        <div class="line-important"></div>
      </div>
      <div class="center-content clearfix">
        <div class="content-item">
          <img src="../../../assets/warehouse-user.png" alt="">负责人：mark
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-country.png" alt="">国家地区：澳大利亚布里斯班
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-phone.png" alt="">电话：07 3103 2888
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-email.png" alt=""> 邮编：4108
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-address.png" alt="">地址：Unit 4&5,33 Stockwell Place,Archerfield,QLD,4108
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-platform.png" alt="">工作时间：周一到周六 9:00 - 6 pm
        </div>
      </div>
    </div>
    <div class="center-item">
      <div class="center-title">
        澳大利亚 珀斯处理中心
        <div class="line"></div>
        <div class="line-important"></div>
      </div>
      <div class="center-content clearfix">
        <div class="content-item">
          <img src="../../../assets/warehouse-user.png" alt="">负责人： Stephen
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-country.png" alt="">国家地区：澳大利亚 珀斯
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-phone.png" alt="">电话：0433001130
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-email.png" alt="">邮编：6055
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-address.png" alt="">地址：2/46 catalano road ,canningvale, WA,6055
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-platform.png" alt="">工作时间：周一到周六 9:00 - 6 pm
        </div>
      </div>
    </div>
    <div class="center-item">
      <div class="center-title">
        加拿大 温哥华处理中心
        <div class="line"></div>
        <div class="line-important"></div>
      </div>
      <div class="center-content clearfix">
        <div class="content-item">
          <img src="../../../assets/warehouse-user.png" alt="">负责人： William
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-country.png" alt="">国家地区：加拿大 温哥华
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-phone.png" alt="">电话：604-2708680
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-email.png" alt="">邮编：V6V 2M3
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-address.png" alt="">地址：110-13431 Maycrest Way, Richmond, BC,
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-platform.png" alt="">工作时间：周一到周六 9:00 - 6 pm
        </div>
      </div>
    </div>
    <div class="center-item">
      <div class="center-title">
        澳大利亚 悉尼处理中心 
        <div class="line"></div>
        <div class="line-important"></div>
      </div>
      <div class="center-content clearfix">
        <div class="content-item">
          <img src="../../../assets/warehouse-user.png" alt="">负责人： Danny Dai
        </div>
        <div class="content-item">
          <img src="../../../assets/warehouse-country.png" alt="">国家地区：澳大利亚 悉尼
        </div>
        <!--<div class="content-item">-->
          <!--<img src="../../../assets/warehouse-phone.png" alt="">电话：0415678766   -->
        <!--</div>-->
        <div class="content-item">
          <img src="../../../assets/warehouse-email.png" alt="">邮编：2200
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-address.png" alt="">地址：9 Homedale Rd. Bankstown
        </div>
        <div class="content-item" style="width: 100%">
          <img src="../../../assets/warehouse-platform.png" alt="">工作时间：周一到周六 9:00 - 6 pm
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        name: "warehouse"
    }
</script>

<style scoped lang="scss">
  .center-item{
    margin-bottom: 30px;
  }
  .center-title{
    font-size: 18px;
    color: rgb(51,51,51);
    font-weight: bolder;
    position: relative;
    height: 40px;
    text-align: left;
  }
  .line{
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    background: rgb(166,166,166);
  }
  .line-important{
    height: 2px;
    background: $bg-color;
    width: 50px;
    position: absolute;
    left: 0;
    bottom: 0;

  }
  .center-content{
    margin-top: 20px;
  }
  .content-item{
    float: left;
    width: 50%;
    text-align: left;
    font-size: 16px;
    color: rgb(102,102,102);
    line-height: 31px;
    margin-top: 10px;
  }
  .content-item img{
    margin-bottom: -3px;
    width: 18px;
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/view/PageService/components/warehouse.vue